'use strict';

function InterlineFaresAdjustmentDirective() {
  return {
    restrict: 'E',
    controller: 'InterlineFaresAdjustmentGridController',
    template: require('../templates/interline-fares-adjustment.html'),
    scope: {}
  };
}
InterlineFaresAdjustmentDirective.$inject = [];
module.exports = InterlineFaresAdjustmentDirective;